import type { CityDto } from '@lunya/contracts'

import type { City } from '../../types'

export function mapCityFromApi(dto: CityDto): City {
  return {
    id: dto.id,
    name: dto.name,
    region: dto.region ?? null,
    country: dto.country,
    lat: dto.lat,
    lon: dto.lon,
    tz: dto.tz,
  }
}
